import { staffClient } from "clients/staff";
import CryptoJS from "crypto-js";
import _ from "lodash";

export namespace StaffApis {
    export const login = async (id: string, password) => {
        try {
            const shadPwd = CryptoJS.SHA256(password).toString();
            const body = {
                user_id: id,
                password: shadPwd
            }
            const ret = await staffClient.post(`/auth/login`, body);
            console.log("[login] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[login] error", e);
            throw e;
        }
    }


    export const resetPassword = async (id: string, password?) => {
        try {
            const body = {
                user_id: id,
            }
            if(!_.isNil(password)) {
                const shadPwd = CryptoJS.SHA256(password).toString();
                body["new_password"] = shadPwd;
            }
            const ret = await staffClient.post(`/auth/reset-password`, body);
            console.log("[handleClick] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[handleClick] error", e);
            throw e;
        }
    }

    export const logout = async () => {
        try {
            const ret = await staffClient.post(`/auth/logout`);
            console.log("[logout] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[logout] error", e);
            throw e;
        }
    }

    export const getMyInfo = async () => {
        try {
            const ret = await staffClient.get(`/auth/my-info`);
            console.log("[getMyInfo] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getMyInfo] error", e);
            throw e;
        }
    }

    export const getMySiteIds = async (): Promise<number[]> => {
        try {
            const ret = await staffClient.get(`/auth/my-sites`);
            return ret.data;
        } catch (e) {
            console.error("[getMySiteIds] error", e);
            throw e;
        }
    }

    export const updateMyProfile = async (staffId: number, data: any) => {
        try {
            const ret = await staffClient.post(`/auth/update-profile`, data);
            return ret.data;
        } catch (e) {
            console.error("[updateMyProfile] error", e);
            throw e;
        }
    }

    // Site Assignment 관련 API
    export const updateSiteAssignment = async (assignmentId: number, assignmentData: any) => {
        try {
            const ret = await staffClient.patch(`/staffs/assignments/${assignmentId}`, assignmentData);
            return ret.data;
        } catch (e) {
            console.error("[updateSiteAssignment] error", e);
            throw e;
        }
    }

    // Education 관련 API
    export const getEducations = async (staffId: number) => {
        try {
            const ret = await staffClient.get(`/staffs/${staffId}/educations`);
            return ret.data;
        } catch (e) {
            console.error("[getEducations] error", e);
            throw e;
        }
    }

    export const addEducation = async (staffId: number, educationData: any) => {
        try {
            const ret = await staffClient.post(`/staffs/${staffId}/educations`, educationData);
            return ret.data;
        } catch (e) {
            console.error("[addEducation] error", e);
            throw e;
        }
    }

    export const updateEducation = async (educationId: number, educationData: any) => {
        try {
            const ret = await staffClient.patch(`/staffs/educations/${educationId}`, educationData);
            return ret.data;
        } catch (e) {
            console.error("[updateEducation] error", e);
            throw e;
        }
    }

    export const removeEducation = async (educationId: number) => {
        try {
            const ret = await staffClient.delete(`/staffs/educations/${educationId}`);
            return ret.data;
        } catch (e) {
            console.error("[removeEducation] error", e);
            throw e;
        }
    }

    // Qualification 관련 API
    export const getQualifications = async (staffId: number) => {
        try {
            const ret = await staffClient.get(`/staffs/${staffId}/qualifications`);
            return ret.data;
        } catch (e) {
            console.error("[getQualifications] error", e);
            throw e;
        }
    }

    export const addQualification = async (staffId: number, qualificationData: any) => {
        try {
            const ret = await staffClient.post(`/staffs/${staffId}/qualifications`, qualificationData);
            return ret.data;
        } catch (e) {
            console.error("[addQualification] error", e);
            throw e;
        }
    }

    export const updateQualification = async (qualificationId: number, qualificationData: any) => {
        try {
            const ret = await staffClient.patch(`/staffs/qualifications/${qualificationId}`, qualificationData);
            return ret.data;
        } catch (e) {
            console.error("[updateQualification] error", e);
            throw e;
        }
    }

    export const removeQualification = async (qualificationId: number) => {
        try {
            const ret = await staffClient.delete(`/staffs/qualifications/${qualificationId}`);
            return ret.data;
        } catch (e) {
            console.error("[removeQualification] error", e);
            throw e;
        }
    }

    // Career 관련 API
    export const getCareers = async (staffId: number, careerType?: string) => {
        try {
            const url = careerType ? `/staffs/${staffId}/careers?type=${careerType}` : `/staffs/${staffId}/careers`;
            const ret = await staffClient.get(url);
            return ret.data;
        } catch (e) {
            console.error("[getCareers] error", e);
            throw e;
        }
    }

    export const addCareer = async (staffId: number, careerData: any) => {
        try {
            const ret = await staffClient.post(`/staffs/${staffId}/careers`, careerData);
            return ret.data;
        } catch (e) {
            console.error("[addCareer] error", e);
            throw e;
        }
    }

    export const updateCareer = async (careerId: number, careerData: any) => {
        try {
            const ret = await staffClient.patch(`/staffs/careers/${careerId}`, careerData);
            return ret.data;
        } catch (e) {
            console.error("[updateCareer] error", e);
            throw e;
        }
    }

    export const removeCareer = async (careerId: number) => {
        try {
            const ret = await staffClient.delete(`/staffs/careers/${careerId}`);
            return ret.data;
        } catch (e) {
            console.error("[removeCareer] error", e);
            throw e;
        }
    }

    // 연차 관리 API
    export const getAnnualLeaveList = async () => {
        try {
            const ret = await staffClient.get('/staffs/annual-leaves');
            return ret.data;
        } catch (e) {
            console.error("[getAnnualLeaveList] error", e);
            throw e;
        }
    }

    export const updateAnnualLeave = async (staffId: number, data: {
        annual_leave_generated?: number;
        annual_leave_used?: number;
        previous_year_advance?: number;
    }) => {
        try {
            const ret = await staffClient.patch(`/staffs/${staffId}/annual-leave`, data);
            return ret.data;
        } catch (e) {
            console.error("[updateAnnualLeave] error", e);
            throw e;
        }
    }

    export const recalculateAllAnnualLeaves = async () => {
        try {
            const ret = await staffClient.post('/staffs/annual-leaves/recalculate');
            return ret.data;
        } catch (e) {
            console.error("[recalculateAllAnnualLeaves] error", e);
            throw e;
        }
    }
}